import { services } from '../app/services.js';
import { AsyncDataPipeable } from '../base/pipeable/async_data_pipeable.js';
import { Checklist } from './checklist.js';
import { FoodMenu } from './food_menu.js';

class TripEntities extends AsyncDataPipeable {
  get menu() {
    if (!this.#menu) {
      this.#menu = new FoodMenu(this.#trip, () => this.menuIdPromise);
    }
    return this.#menu;
  }

  get checklist() {
    if (!this.#checklist) {
      this.#checklist = new Checklist(
        this.#trip,
        () => this.checklistIdPromise
      );
    }
    return this.#checklist;
  }

  get checklistIdPromise() {
    return this.#getData().then(() => this.data.checklistId);
  }

  get menuIdPromise() {
    return this.#getData().then(() => this.data.menuId);
  }

  getLoadPromise() {
    return services.trip.getEntities(this.#trip.id);
  }

  get dataClassName() {
    return 'trip-entities';
  }

  toString() {
    return `TripEntities`;
  }

  constructor(trip) {
    super();
    this.#trip = trip;
  }

  #getData() {
    return Promise.resolve(this.loadIfNeeded()).then(() => this.data);
  }

  #trip;
  #menu;
  #checklist;
}

export { TripEntities };
